'use client';

import PropTypes from 'prop-types';
import {capitalizeFirstLetter} from "@/utils/strings.ts";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import Iconify from "src/components/iconify";

function RecipeEquipmentList({recipeData}) {
  if (!recipeData.equipments || recipeData.equipments.length < 1) {
    return '';
  }

  return (
    <Stack spacing={2}>
        <Typography variant="h6">Wymagane przyrządy kuchenne</Typography>

        <Box
          rowGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
        >
          {recipeData.equipments.map((equipment, index) => (
            <Stack
              key={equipment.id || equipment.code || `equipment-${index}`}
              spacing={1}
              direction="row"
              alignItems="center"
            >
              <Iconify
                icon="eva:checkmark-circle-2-outline"
                sx={{
                  color: 'primary.main'
                }}
              />
              {capitalizeFirstLetter(equipment.name)}
            </Stack>
          ))}
        </Box>
      </Stack>
  );
}

RecipeEquipmentList.propTypes = {
  recipeData: PropTypes.object
};

export default RecipeEquipmentList;
